// This file was automatically generated from appchart.refpanel.maintItems.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.maintItems');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.render.decisionSupports');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="maint-items-container el8MainFormContainer"><div class="maint-items-list-pane el8MaintLeftNavContainer el8OverflowAuto"></div><div class="vertical-divider"></div><div class="maint-items-detail-pane el8MaintContainerWithLeftNav"></div><div class="clearfix"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="ebs-list-unstyled"><li class="el8StandardFontSize el8NavMenuItem description-trigger mt5"><a class="">Description</a></li></ul><ul><li class="el8StandardFontSize el8NavMenuItem add-new-trigger mt5 mb5"><a class="">+ Add New Item</a></li>');
  var itemList5425 = opt_data.items;
  var itemListLen5425 = itemList5425.length;
  for (var itemIndex5425 = 0; itemIndex5425 < itemListLen5425; itemIndex5425++) {
    var itemData5425 = itemList5425[itemIndex5425];
    output.append('<li class="item-trigger el8StandardFontSize', (opt_data.currentItemOrSourceId && (itemData5425.id == opt_data.currentItemOrSourceId || itemData5425.sourceId == opt_data.currentItemOrSourceId)) ? ' el8NavMenuItemSelected ebs-active' : ' el8NavMenuItem', '"><a class="select-trigger" data-id="', soy.$$escapeHtml(itemData5425.id), '" data-source-id="', soy.$$escapeHtml(itemData5425.sourceId), '">', soy.$$escapeHtml(itemData5425.date), '</a>', (opt_data.rule.isShowResultFlag) ? (itemData5425.isAbnormal) ? '<span class="abnormal-tag">' + soy.$$escapeHtml(opt_data.rule.abnormalResultFlagText) + '</span>' : '' : '', '</li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.addEditForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="view-pane add-edit-container"><form class="add-new-maint-item-form"><div class="el8FieldSection mt20"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Date</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap w25"><input type="text" class="w87" name="date" /></div></div><div class="el8FieldSection type-container"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Type:</span></label><div class="doctags-holder el8FieldLongLabelPadding"></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong"><span class="el8FieldSection">Note</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="note"></textarea></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong"><span class="el8FieldSection">Provider</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap provider"></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong"><span class="el8FieldSection"></span></label><div class="el8FieldLongLabelPadding mt10"><a class="el8StandardFontSize link-report-trigger">+ Link a report to this item</a> <a class="el8StandardFontSize el8Hidden view-report-trigger">View Report</a>  <a class="el8StandardFontSize el8Hidden el8RemoveButtonStatic padl5 remove-report-trigger"></a></div><div class="add-new-button-elt el8AlignLeft" style="margin: 20px 0px 3px 10px"></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.ambientOrExclusionItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="view-pane ambient-item-container"><div class="el8StandardFontSize" style="padding:20px;">', (opt_data.exclusionYear) ? ' <span style="font-weight:bold;margin-right:10px;">Excluded for ' + soy.$$escapeHtml(opt_data.exclusionYear) + '</span>' : '', soy.$$escapeHtml(opt_data.reasonDescription), ' ', (opt_data.code) ? '(' + soy.$$escapeHtml(opt_data.codeType) + ' code: <span class="el8Code">' + soy.$$escapeHtml(opt_data.code) + '</span>)' : '', '<div class="mt10 ml5">&bull; ');
  el8.template.appchart.refpanel.maintItems.ambientItemSummary({item: opt_data.item}, output);
  output.append('</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.ambientItemSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.item.modelClass) {
    case 'PatientProblem':
      el8.template.appchart.refpanel.maintItems.customSummary({date: opt_data.item.startDate, title: 'Problem List'}, output);
      break;
    default:
      el8.template.ptdata.letters.attachments.clientGeneratedAttachmentSummary(opt_data.item, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.customSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8AttachmentDate">', soy.$$escapeHtml(opt_data.date), '</span><span class="el8AttachmentTitle">', soy.$$escapeHtml(opt_data.title), '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.maintItems.description = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="view-pane measure-description-container"><div class="padt20 padb20 padl20">');
  el8.template.render.decisionSupports.cdsRecommendation({nqfCode: opt_data.cdsIdentifier}, output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};
